module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-switch@1.9.0@rc-switch/es/index.js
// module id = 2522
// module chunks = 0